import type { Ref } from 'vue';
import type { IOrderStore } from '@sub/stores/order';

export function useOrderWarningModal(routerServiceId: Ref<number>, order: Ref<IOrderStore>) {
  const showWarning = ref(false);

  const serviceId = ref(routerServiceId.value);

  watch(routerServiceId, () => {
    if (routerServiceId.value === 0) return;
    if (order.value.dates && order.value.service?.id !== routerServiceId.value) {
      showWarning.value = true;
    } else {
      updateService();
    }
  });

  function updateService() {
    serviceId.value = routerServiceId.value;
  }

  function keepService() {
    routerServiceId.value = serviceId.value;
    //
  }

  return {
    serviceId,
    showWarning,
    keepService,
    updateService,
  };
}